import { Injectable, computed, effect, inject, signal, untracked } from "@angular/core";

import { Subject } from "rxjs";

import { AlertBadge, ClientSettings } from "@models";

import { AlertService } from "./alert.service";

@Injectable({ providedIn: "root" })
export class ClientService {
  private readonly alS = inject(AlertService);

  public ref$ = new Subject<void>();

  /*Settings FE*/
  public sF$ = signal<ClientSettings>({} as ClientSettings);
  /*Disconnected*/
  public dis$ = signal<boolean | null>(null);
  /*Unauthorized*/
  public una$ = signal<boolean | null>(null);

  public stop$ = computed<boolean | null>(() => this.dis$() || this.una$());

  private key: string;

  constructor() {
    effect(() => {
      if (this.una$()) {
        const base = "error.unauthorized";

        this.alS.show({ text: `${base}.title`, badge: AlertBadge.W, infinite: true });
      }
    });

    effect(() => {
      const disconnected = this.dis$();
      if (disconnected === null) {
        return;
      }

      const base = "error.network";

      if (disconnected) {
        this.alS.show({ text: `${base}.disconnected`, badge: AlertBadge.W, infinite: true });
      } else {
        this.alS.clear();

        this.alS.show({ text: `${base}.connected`, badge: AlertBadge.S });
      }
    });
  }

  private readonly clickFn = (event: Event): void => {
    if (!event.isTrusted) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  };

  public init(game_id: number): void {
    this.key = `mn.${game_id}.client-settings`;

    let settings: ClientSettings;

    try {
      settings = JSON.parse(localStorage.getItem(this.key) || "{}");
    } catch {
      settings = {} as ClientSettings;
    }

    this.sF$.set(settings);

    document.addEventListener("click", this.clickFn, true);
  }

  public destroy(): void {
    document.removeEventListener("click", this.clickFn, true);
  }

  public set(key: keyof ClientSettings, value: unknown): void {
    const settings = { ...untracked(this.sF$), [key]: value };
    this.sF$.set(settings);
    localStorage.setItem(this.key, JSON.stringify(settings));
  }
}
